import clsx from "clsx";

const CakeIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
    <defs>
      <linearGradient
        id="pet-bday-cake"
        x1="2"
        y1="2"
        x2="22"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DB2777" />
        <stop offset="1" stopColor="#9333EA" />
      </linearGradient>
    </defs>
    <path
      d="M12 2.25c.9.75 1.35 1.5 1.35 2.25a1.35 1.35 0 0 1-2.7 0c0-.75.45-1.5 1.35-2.25Z"
      fill="url(#pet-bday-cake)"
    />
    <path
      d="M12 5.4v3.1"
      stroke="url(#pet-bday-cake)"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M5 12.2c0-1.55 1.26-2.8 2.8-2.8h8.4c1.54 0 2.8 1.25 2.8 2.8v.8c-1.1 0-1.1 1.1-2.2 1.1s-1.1-1.1-2.2-1.1-1.1 1.1-2.2 1.1-1.1-1.1-2.2-1.1-1.1 1.1-2.2 1.1S6.1 13 5 13v-.8Z"
      fill="url(#pet-bday-cake)"
    />
    <path
      d="M4.5 14.4c1.2 0 1.2 1.1 2.3 1.1s1.1-1.1 2.2-1.1 1.1 1.1 2.2 1.1 1.1-1.1 2.2-1.1 1.1 1.1 2.2 1.1 1.2-1.1 2.4-1.1v5.35c0 .5-.4.9-.9.9H5.4a.9.9 0 0 1-.9-.9V14.4Z"
      fill="url(#pet-bday-cake)"
      fillOpacity="0.55"
    />
    <path
      d="M3 21.4h18"
      stroke="url(#pet-bday-cake)"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const PetBirthdayIcon: React.FC<{
  hasBirthday?: boolean;
  petName?: string;
  className?: string;
}> = (props) => {
  if (!props?.hasBirthday) return null;

  const name = props?.petName?.trim();

  return (
    <span
      role="status"
      aria-label={name ? `Happy Birthday ${name}` : "Happy Birthday"}
      title={name ? `Happy Birthday ${name}` : "Happy Birthday"}
      className={clsx(
        "ml-1 inline-flex max-w-full items-center gap-1 rounded-full border border-[#FBCFE8]",
        "bg-gradient-to-r from-[#FDF2F8] via-[#FCE7F3] to-[#F5E8FF]",
        "px-2 py-[2px] align-middle shadow-[0_1px_2px_rgba(219,39,119,0.12)]",
        props?.className,
      )}
    >
      <CakeIcon className="h-4 w-4 shrink-0 drop-shadow-[0_1px_1px_rgba(219,39,119,0.25)]" />
      <span className="truncate bg-gradient-to-r from-[#DB2777] to-[#9333EA] bg-clip-text text-[0.6875rem] font-semibold leading-[1.2] text-transparent">
        Happy Birthday{name ? ` ${name}` : ""}
      </span>
    </span>
  );
};

export default PetBirthdayIcon;
